export enum SORT_ORDER {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type SortType<SortableField extends string> = {
  field: SortableField;
  order: SORT_ORDER;
};
